import React from 'react';
import { BasicComponentProps } from '@whoop/web-components/dist/types';
import { ConsentItem as ConsentItemModel } from 'types/consent';
import styles from './index.module.scss';

type ConsentItemProps = {
  consentItem: ConsentItemModel;
} & BasicComponentProps;

function ConsentItem({ consentItem, ...props }: ConsentItemProps) {
  const { title, description, image } = consentItem;
  return (
    <div className={styles.root} {...props}>
      <div className={styles.iconWrapper}>
        <img src={image.src} alt={image.alt} className={styles.icon} />
      </div>
      <div>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  );
}

export default ConsentItem;
